import type { ReactNode } from 'react';

type SectionCardProps = {
  title: string;
  description: string;
  /** 헤더 오른쪽 영역. 상태 칩이나 카운트 배지를 넣는다. */
  actions?: ReactNode;
  children: ReactNode;
};

/**
 * 프로젝트 설정 화면의 카드 껍데기.
 *
 * 설정 화면의 섹션들이 각자 카드를 그리면 테두리·패딩·헤더 간격이 조금씩 어긋난다.
 * 껍데기를 한 곳에 두어 섹션이 늘어나도 같은 모양을 유지한다.
 */
export const SectionCard = ({ title, description, actions, children }: SectionCardProps) => (
  <section className="rounded-2xl border border-base-300 bg-base-100 shadow-xs">
    <div className="flex min-w-0 items-start justify-between gap-4 border-b border-base-300 px-4 py-3">
      <div className="min-w-0">
        <h3 className="truncate text-sm font-semibold text-base-content">{title}</h3>
        <p className="mt-1 text-xs leading-5 text-[var(--color-fg-muted)]">{description}</p>
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </div>
    <div className="p-4">{children}</div>
  </section>
);

export default SectionCard;
